import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import logo1 from "../../src/assets/Logo/logo1.png";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setTimeout(() => {
      navigate(path);
    }, 100);
  };

  return (
    
    <motion.footer
      className="bg-gray-900 text-white py-8 md:py-10 mt-8 text-center"
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 justify-center items-center text-center">
          <div className="flex flex-col items-center justify-center">
            <img
              src={logo1}
              alt="Logo"
              className="w-[150px] h-auto max-h-[200px]"
            />
            <span className="font-extrabold text-2xl text-orange-400 tracking-tight ">
              Spectrum Nurturing Academy
            </span>
          </div>

          <div>
            <div className="mb-2 font-semibold">Mailing & Street Address</div>
            <div className="text-sm sm:text-base">
              House-16, Sector-I, Block-F,
              <br />
              Aftabnagar, Dhaka, Bangladesh
            </div>
            <div className="mt-2 text-xs sm:text-sm text-gray-400">
              Phone: 01711-727-199 <br />
              Email:{" "}
              <a href="mailto:admissions@sna-bd.org">
                <span className="text-blue-600 underline">
                  admissions@sna-bd.org
                </span>
              </a>
              <br />
              Website:{" "}
              <a href="https://www.sna-bd.org">
                <span className="text-blue-600 underline">
                  https://www.sna-bd.org
                </span>
              </a>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center gap-2">
            <button
              onClick={() => handleNavigation("/privacy-policy")}
              className="text-sm sm:text-base hover:underline text-white bg-transparent border-none cursor-pointer"
            >
              Privacy Policy
            </button>
            <button
              onClick={() => handleNavigation("/terms-and-conditions")}
              className="text-sm sm:text-base hover:underline text-white bg-transparent border-none cursor-pointer"
            >
              Terms & Conditions
            </button>
          </div>
        </div>
        <div className="text-center text-gray-400 text-xs mt-8">
          &copy; {new Date().getFullYear()} Spectrum Nurturing Academy. All
          rights reserved. <br />
          Powered By <a href="https://zensoftlab.com/">Zensoft Lab</a>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
